import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import SubmmisionsList from "./SubmmisionsList/SubmmisionsList";
import AssessmentsFilterList from "./AssessmentList/AssessmentsFilterList";
import Player from "../../../../cms/Player/Player";
import BackdropPopup from "../../../../lms-shared/UI/Popups/BackdropPopup/BackdropPopup";

import { assessmentsApi, participantsApi, submissionsApi, lessonsApi } from '../../../../../utils'
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import { ParticipantTypeEnumText } from "../../../../../models/ParticipantTypeEnum";

import classes from "./AnswerTracking.module.css";
import { SourceTypeTextEnum } from "../../../../../models/SourceTypeEnum";
import { ActivityTypeEnumText } from "../../../../../models/ActivityTypeEnum";
// import { getCurrentAssessment } from "./Shared/utils"

const AnswerReport = () => {
    const dispatch = useDispatch();

    const { texts, lang } = useSelector(state => state.translate);

    const [students, setStudents] = useState()
    const [answersReportData, setAnswersReportData] = useState({
        assessments: [],
        submissions: [],
        currentAssessmentId: "",
        msg: null
    })
    const { guid, id } = useParams(); // id = studyGroupId , guid = tocId
    const [lessonData, setLessonData] = useState()
    useEffect(() => {
        // get participant for each studygroup
        getParticipant()
    }, [id])

    useEffect(() => {
        if (id && guid && students) {
            getData();
        }
    }, [id, guid, students])

    const customSort = (a, b) => {
        const getNumericValue = (str) => parseInt(str.match(/^(d+)/)) || 0;

        const numericValueA = getNumericValue(a);
        const numericValueB = getNumericValue(b);

        if (numericValueA !== numericValueB) {
            return numericValueA - numericValueB;
        } else {
            return a.localeCompare(b, lang, { numeric: true, });
        }
    }

    const getData = async () => {
        const assessments = await fetchAssessments();
        let subAssessmentsArray;
        if (assessments.length > 0) {
            if (assessments.some(assessment => assessment.sourceType === "SLCQuestionnaire")) {
                subAssessmentsArray = assessments.sort((a, b) => a.sortIndex - b.sortIndex).flatMap((parentAssessment, parentIndex) =>
                    parentAssessment.subAssessments.map(subAssessment => ({
                        ...subAssessment,
                        parentIndex,
                    }))
                ).sort((a, b) => a.parentIndex !== b.parentIndex ? a.parentIndex - b.parentIndex : a.sortIndex - b.sortIndex);
            }
            else {
                subAssessmentsArray = assessments.sort((a, b) => a.sortIndex - b.sortIndex).flatMap(parentAssessment => [...parentAssessment.subAssessments])
                subAssessmentsArray = subAssessmentsArray.sort((a, b) => customSort(a.parentName, b.parentName));
            }
            if (subAssessmentsArray.length > 0) {
                const currebtSubmmissions = await fetchSubmmissions(subAssessmentsArray?.[0]?.id)
                setAnswersReportData(prevState => ({
                    ...prevState,
                    assessments: subAssessmentsArray,
                    submissions: currebtSubmmissions,
                    currentAssessmentId: subAssessmentsArray?.[0]?.id,
                    msg: null
                }))
            }
            else {
                setAnswersReportData(({
                    msg: <div className={classes.NoDataToView}>{texts.noDataToView}</div>
                }))
            }
        }
        else {
            setAnswersReportData(({
                msg: <div className={classes.NoDataToView}>{texts.noDataToView}</div>
            }))
        }
    }

    const fetchSubmmissions = (assessmentId) => new Promise((resolve, reject) => {
        const data = {
            studyGroupId: id,
            assessmentId: assessmentId,
            sourceTypes: [SourceTypeTextEnum.SLCQuestionnaire, SourceTypeTextEnum.StorylineQuestionnaire],
            allParticipants: true,
        }
        submissionsApi.submissionsFilterRangePost({ submissionsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.submissionsFilterError, error: error, statusCode: response?.statusCode, message: "submissionsFilterRangePost " + error.message, level: 1, component: "LearningTrackingAssessments", line: 41 }))
            }
            else {
                const submissions = students?.map(student => {
                    let userSubmission = resdata.find(s => s.submittedByUser.id == student.id || s.submittedByUser.users?.find(u => u.id == student.id));
                    if (!userSubmission) {
                        userSubmission = {
                            submittedByFirstName: student.user?.firstName,
                            submittedByLastName: student.user?.lastName,
                            solution: null,
                            fullSolution: null
                        }
                    }
                    return { ...userSubmission, submittedByFirstName: student.user?.firstName, submittedByLastName: student.user?.lastName };
                });
                resolve(submissions)
            }
        })
    })

    const fetchAssessments = () => new Promise((resolve, reject) => {
        const data = {
            studyGroupId: id,
            toCId: guid,
            activityType: ActivityTypeEnumText.Learning,
            includeSubmissionAggregation: true
        }
        assessmentsApi.assessmentsFilterRangePost({ assessmentFilterRange: data }, async (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: error, error: error, statusCode: response?.statusCode, message: "assessmentsFilterRangePost " + error.message, level: 1, component: "LearningTrackingAssessments", line: 120 }))
            }
            else {
                resolve(resdata?.assessments)
            }
        })
    })


    const getParticipant = () => {
        const data = {
            studyGroupId: id,
            participantType: ParticipantTypeEnumText.student,
        }
        participantsApi.participantsFilterRangePost({ participantsRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.participantsFilterError, error: error, statusCode: response?.statusCode, message: "participantsFilterRangePost " + error.message, level: 2, component: "SelectStudents", line: 128 }))
            }
            else {
                setStudents(resdata)
            }
        })
    }

    const handeleShowLesson = () => {
        const lessonId = answersReportData?.assessments.find(a => a.id == answersReportData?.currentAssessmentId)?.lessonId;
        lessonsApi.lessonsFilterPost({ lessonFilter: { id: lessonId } }, (error, resdata, response) => {
            if (error) {
                let txt = texts.lessonsFilterError;
                if (error.status == 403) {
                    txt = texts.studentsAreNotAllowShowInactiveLesson;
                }
                dispatch(throwApiError({ userMessage: txt, error: error, statusCode: response?.statusCode, message: "lessonsFilterPost " + error.message, level: 2, component: "LessonViewer", line: 23 }))
                setLessonData(null)
            }
            else {
                setLessonData(resdata)
            }
        })
    }

    const setCurrentAssessmentId = async (assessmentId) => {
        const currentSubmmissions = await fetchSubmmissions(assessmentId)
        setAnswersReportData(
            prevState => ({
                ...prevState,
                submissions: currentSubmmissions,
                currentAssessmentId: assessmentId
            })
        )
    }

    const setSubmissionScore = (newSubmissions, newAssessments) => {
        setAnswersReportData(prevState => ({
            ...prevState,
            assessments: newAssessments,
            submissions: newSubmissions
        }))
    }

    return (
        <>
            {!answersReportData.msg ?
                <>
                    <div className={classes.AnswerTracking}>
                        <AssessmentsFilterList {...answersReportData} setCurrentAssessmentId={setCurrentAssessmentId} />
                        <SubmmisionsList
                            currentAssessment={answersReportData.assessments?.find(a => a.id === answersReportData.currentAssessmentId)}
                            submissions={answersReportData.submissions}
                            handeleShowLesson={handeleShowLesson}
                            lessonData={lessonData}
                            setSubmissionScore={setSubmissionScore}
                            assessments={answersReportData.assessments}
                            title={answersReportData.assessments.find(a => a.id == answersReportData.currentAssessmentId)}
                        />
                    </div>
                    {lessonData &&
                        <BackdropPopup>
                            <div className={classes.PreviewSlide}>
                                <Player contentDirPath={`${lessonData.materialContentPath}/`} lessonId={lessonData.id} submissions={answersReportData.submissions} questionExtranelId={answersReportData?.assessments.find(a => a.id == answersReportData?.currentAssessmentId)?.externalId}></Player>
                            </div>
                            <div className={classes.ClosePreview} onClick={() => setLessonData(null)} >x</div>
                        </BackdropPopup>
                    }
                </>
                :
                <> {answersReportData.msg}</>
            }
        </>
    )
}
export default AnswerReport